import { Component } from '@angular/core';
import { AbstractAppComponent } from '@shared/components/abstracts/abstract-app.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends AbstractAppComponent {
  constructor() {
    super(
      `Votre source de confiance pour votre prochaine achat`,
      `Découvrez l'historique complet de chaque voiture d'occasion. Nos rapports détaillés vous offrent une transparence totale, vous permettant d'acheter ou de vendre en toute confiance. Rejoignez-nous dès maintenant !`
    );
  }
}
